import React from 'react';
import { Redirect, Route } from "react-router-dom";
import AuthService from '../services/AuthService';

const PrivateRoute = ({ component: Component, render, roles, ...rest }) => {
    return (
        <Route 
            {...rest} 
            render={props => {
                const currentUser = AuthService.getCurrentUser();
                
                if (!currentUser) {
                    // not logged in so redirect to login page with the return url
                    return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                }
                
                // check if route is restricted by role
                if (roles && roles.length > 0) {
                    // check that every role is included in currentUser roles
                    const hasRequiredRole = roles.some(role => 
                        currentUser.roles && currentUser.roles.includes(role)
                    );
                    
                    if (!hasRequiredRole) {
                        // role not authorised so redirect to home page
                        return <Redirect to={{ pathname: '/' }} />
                    }
                }
                
                // Use render prop if provided, otherwise use component prop
                if (render) {
                    return render(props);
                }
                
                // If no render prop but component exists, render the component
                if (Component) {
                    return <Component {...props} />;
                }
                
                // If neither render nor component is provided, render null
                return null;
            }}
        />
    );
};

export default PrivateRoute;